import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BERoboticsCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Robotics and Automation",
    shortName: "B.E. Robotics",
    duration: "4 years",
    description: "Specialized engineering program focused on designing, building, and programming robotic systems and automation technologies",
    overview: "Bachelor of Engineering in Robotics and Automation (B.E. Robotics) is a 4-year undergraduate program that combines mechanical engineering, electrical engineering, computer science, and artificial intelligence to develop advanced robotic systems. This cutting-edge course prepares students for the future of automation, intelligent machines, and Industry 4.0 technologies.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Strong interest in robotics and automation"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Introduction to Robotics",
          "Programming Fundamentals"
        ]
      },
      {
        year: 2,
        subjects: [
          "Mechanics and Materials",
          "Electrical and Electronics",
          "Digital Logic Design",
          "Object-Oriented Programming",
          "Sensors and Actuators",
          "Control Theory"
        ]
      },
      {
        year: 3,
        subjects: [
          "Robot Kinematics and Dynamics",
          "Microprocessors and Embedded Systems",
          "Machine Learning for Robotics",
          "Computer Vision",
          "Industrial Automation",
          "Mobile Robotics"
        ]
      },
      {
        year: 4,
        subjects: [
          "Artificial Intelligence in Robotics",
          "Autonomous Systems",
          "Human-Robot Interaction",
          "Swarm Robotics",
          "Major Project",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Robotics Engineer",
        "Automation Engineer",
        "AI/ML Engineer",
        "Research Scientist",
        "Product Development Engineer",
        "Systems Integration Engineer",
        "Autonomous Vehicle Engineer",
        "Robotics Software Developer"
      ],
      industries: [
        "Robotics Companies",
        "Automotive (Autonomous Vehicles)",
        "Aerospace and Defense",
        "Medical and Healthcare",
        "Manufacturing and Production",
        "Agriculture Technology",
        "Space Technology",
        "Entertainment and Gaming"
      ],
      averageSalary: "₹8-15 LPA (Fresher), ₹25-60 LPA (Experienced)",
      topRecruiters: [
        "Boston Dynamics, Tesla",
        "ISRO, DRDO",
        "Microsoft, Google, Amazon",
        "ABB, Siemens, KUKA",
        "Mahindra, Tata Motors",
        "Intuitive Surgical, Medtronic"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "VIT University",
        location: "Vellore",
        fees: "₹7,83,000",
        ranking: "NIRF Ranking: 15"
      },
      {
        name: "SRM Institute of Science and Technology",
        location: "Chennai",
        fees: "₹12,00,000",
        ranking: "NIRF Ranking: 41"
      },
      {
        name: "Manipal Institute of Technology",
        location: "Manipal",
        fees: "₹15,00,000",
        ranking: "NIRF Ranking: 45"
      },
      {
        name: "Amrita Vishwa Vidyapeetham",
        location: "Coimbatore",
        fees: "₹3,04,000",
        ranking: "NIRF Ranking: 38"
      }
    ],

    skills: [
      "Robot Programming (ROS, Python, C++)",
      "Machine Learning and AI",
      "Computer Vision",
      "Control Systems",
      "Embedded Systems Programming",
      "CAD/CAM Design",
      "Sensor Integration",
      "Path Planning Algorithms",
      "MATLAB/Simulink",
      "Project Management"
    ],

    futureScope: "Exceptional growth potential with robotics revolutionizing industries like healthcare, manufacturing, agriculture, space exploration, and daily life automation.",

    faqs: [
      {
        question: "What career opportunities exist in robotics?",
        answer: "Robotics offers diverse opportunities from developing autonomous vehicles to medical robots, space exploration, manufacturing automation, and AI research."
      },
      {
        question: "Do I need strong programming skills?",
        answer: "Yes, programming is essential in robotics. Students learn multiple languages including Python, C++, and specialized frameworks like ROS (Robot Operating System)."
      },
      {
        question: "Can I work internationally?",
        answer: "Absolutely. Robotics is a global field with opportunities in Silicon Valley, Europe, Japan, and other technology hubs worldwide."
      },
      {
        question: "What about research and higher studies?",
        answer: "Excellent options for M.S./Ph.D. in Robotics, AI, or related fields at top universities like MIT, Stanford, CMU, and leading Indian institutions."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BERoboticsCoursePage;
